import { jwtDecode } from "jwt-decode";
import { JwtPayload } from '../interfaces/jwt-payload';

export type { JwtPayload } from '../interfaces/jwt-payload';

export function getTokenExpiration(token: string): number {
    const decoded = jwtDecode<JwtPayload>(token);
    return decoded.exp * 1000; // convert to ms
}
